import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

function LanguageSelector() {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'it', label: 'Italiano' }
  ];

  // Get the base language code (e.g., 'en' from 'en-US')
  const currentLang = i18n.language?.split('-')[0] || 'en';

  return (
    <div className="language-selector">
      {languages.map(lang => (
        <button
          key={lang.code}
          type="button"
          className={`lang-btn ${currentLang === lang.code ? 'active' : ''}`}
          onClick={() => {
            i18n.changeLanguage(lang.code);
            localStorage.setItem('language', lang.code);
            // Backward compatibility: some setups use this key by default.
            localStorage.setItem('i18nextLng', lang.code);
          }}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSelector;

